import type { AgentDeployment, AgentRelease } from '../types';

export const SCOPE_LABEL: Record<string, string> = {
  PUBLIC: 'Public',
  APPLICATION: 'Application',
  TENANT: 'Tenant',
};

export const TYPE_LABEL: Record<string, string> = {
  TASK: 'Task',
  CONVERSATIONAL: 'Conversational',
};

export function releaseVariant(
  s: AgentRelease['status'],
): 'success' | 'warning' | 'secondary' | 'destructive' {
  if (s === 'PUBLISHED') return 'success';
  if (s === 'DEPRECATED') return 'destructive';
  return 'warning'; // DRAFT
}

export function deploymentVariant(
  s: AgentDeployment['status'],
): 'success' | 'warning' | 'secondary' | 'destructive' {
  if (s === 'ACTIVE') return 'success';
  if (s === 'ARCHIVED' || s === 'FAILED') return 'destructive';
  if (s === 'INACTIVE') return 'warning';
  return 'secondary';
}

export function fmt(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { dateStyle: 'medium' });
}
